"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settlementGuideDialogState_1 = require("./settlementGuideDialogState");
const react_i18next_1 = require("react-i18next");
const functions_1 = require("@/common/functions");
const ToggleButtonGroup_1 = __importDefault(require("@mui/material/ToggleButtonGroup"));
const ToggleButton_1 = __importDefault(require("@mui/material/ToggleButton"));
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const guideTabVal = (0, recoil_1.useRecoilValue)(settlementGuideDialogState_1.settlementGuideTabState);
    const isLeaderTab = guideTabVal === 'leader';
    const isUsedTransferTab = guideTabVal === 'used/transfer';
    const [leaderSubTabVal, setLeaderSubTabVal] = (0, recoil_1.useRecoilState)(settlementGuideDialogState_1.settlementGuideLeaderSubTabState);
    const [usedTransferSubTabVal, setUsedTransferSubTabVal] = (0, recoil_1.useRecoilState)(settlementGuideDialogState_1.settlementGuideUsedTransferSubTabState);
    const { t } = (0, react_i18next_1.useTranslation)();
    const leaderSubTabObjArr = [
        { label: 'guide_sub_tab_product_cost', value: 'productCost', name: t('제작비') },
        { label: 'guide_sub_tab_agency_purchase', value: 'agencyPurchase', name: t('구매대행') },
        { label: 'guide_sub_tab_handmade', value: 'handmade', name: t('핸드메이드') },
        { label: 'guide_sub_tab_event', value: 'event', name: t('행사') },
        { label: 'guide_sub_tab_shipping_fee', value: 'shippingFee', name: t('배송비') },
    ];
    const usedTransferSubTabObjArr = [
        { label: 'guide_sub_tab_cash', value: 'cash', name: t('현물') },
        { label: 'guide_sub_tab_transfer', value: 'transfer', name: t('폼양도') },
        { label: 'guide_sub_tab_combined_transfer', value: 'combinedTransfer', name: t('합배송 양도') },
    ];
    const { scrollDiv, setScrollDiv, centerTarget } = (0, functions_1.useHorizontalDragScroll)(isLeaderTab);
    (0, react_1.useEffect)(() => {
        if (isLeaderTab && !!scrollDiv) {
            centerTarget(document.querySelector('#selected_sub_tab'));
        }
    }, [isLeaderTab, leaderSubTabVal, scrollDiv]);
    if (isLeaderTab)
        return ((0, jsx_runtime_1.jsx)(SettlementGuideSubTabTBG, Object.assign({ ref: setScrollDiv, className: "horizontal_drag_scroll no_scroll_bar", "aria-label": "settlement_leader_sub_tab", exclusive: true, value: leaderSubTabVal, onChange: (_, val) => {
                if (val !== null) {
                    setLeaderSubTabVal(val);
                }
            } }, { children: leaderSubTabObjArr.map((leaderSubTabObj, index) => {
                const { label, value, name } = leaderSubTabObj;
                const isSelected = leaderSubTabVal === value;
                return ((0, jsx_runtime_1.jsx)(ToggleButton_1.default, Object.assign({ "aria-label": label, value: value, id: isSelected ? 'selected_sub_tab' : undefined }, { children: name }), `${label}_${index}`));
            }) })));
    if (isUsedTransferTab)
        return ((0, jsx_runtime_1.jsx)(SettlementGuideSubTabTBG, Object.assign({ "aria-label": "settlement_used_transfer_sub_tab", exclusive: true, value: usedTransferSubTabVal, onChange: (_, val) => {
                if (val !== null) {
                    setUsedTransferSubTabVal(val);
                }
            } }, { children: usedTransferSubTabObjArr.map((usedTransferSubTabObj, index) => {
                const { label, value, name } = usedTransferSubTabObj;
                return ((0, jsx_runtime_1.jsx)(ToggleButton_1.default, Object.assign({ "aria-label": label, value: value }, { children: name }), `${label}_${index}`));
            }) })));
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
}
exports.default = default_1;
const SettlementGuideSubTabTBG = (0, styled_1.default)(ToggleButtonGroup_1.default) `
  display: flex;
  column-gap: 8px;
  padding: 0 20px;
  border-radius: 0;
  .MuiToggleButton-root {
    flex-shrink: 0;
    height: 32px;
    padding: 0 12px;
    border-radius: 50px !important;
    border: 1px solid var(--gray-10) !important;
    line-height: 22px;
    font-size: 15px;
    background-color: white;
    color: var(--gray-80);
    &.Mui-selected {
      border: 0 !important;
      font-weight: bold;
      background-color: var(--gray-80);
      color: var(--white);
    }
  }
`;
